import axiosHttp from "services/axiosHttp";
import { message } from "antd";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const checkoutGatepass = createAsyncThunk(
	"checkoutGatepass",
	async (id, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`gatepass/checkout/${id}`);
			message.success(response.data?.message || "Gatepass checked out successfully");
			return response.data;
		} catch (err) {
			if (!err.response) throw err;
			message.error(err.response.data?.message || "Failed to checkout gatepass");
			return rejectWithValue(err.response.data);
		}
	}
);

const GatepassCheckoutSlice = createSlice({
	name: "GatepassCheckoutSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetGatepassCheckout: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(checkoutGatepass.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(checkoutGatepass.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(checkoutGatepass.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetGatepassCheckout } = GatepassCheckoutSlice.actions;
export default GatepassCheckoutSlice.reducer;
